import React, { ReactElement } from "react";

import { ROUTES } from "@config/soft.routing";

import { Column, Row } from "@ui/Atoms/Grid";
import { OptionPanel } from "@ui/Atoms";
import { StepProgress } from "@ui/Molecules";

import { useTranslate } from "@hooks/useTranslate";

const routeToStepMap: { [k: string]: number } = {
  [ROUTES.DECLARE_EMPLOYEE]: 1,
  [ROUTES.DECLARE_EMPLOYEE_SALARY]: 2,
  [ROUTES.DECLARE_EMPLOYEE_CHECKOUT]: 3,
};

interface Props {
  currentPath: string;
}

const FormHeader = (props: Props): ReactElement => {
  const translate = useTranslate("batsoft_pwa_declare_employee");

  return (
    <OptionPanel isThin>
      <Row>
        <Column lg={8} pushLg={2}>
          <StepProgress
            activeStep={routeToStepMap[props.currentPath]}
            steps={[
              {
                label: translate("step_employee_details"),
                route: ROUTES.DECLARE_EMPLOYEE,
              },
              {
                label: translate("step_salary"),
                route: ROUTES.DECLARE_EMPLOYEE_SALARY,
              },
              {
                label: translate("step_checkout"),
                route: ROUTES.DECLARE_EMPLOYEE_CHECKOUT,
              },
            ]}
          />
        </Column>
      </Row>
    </OptionPanel>
  );
};

export { FormHeader };
